import * as types from '../../action-types';
import {addEmployment as initialState } from "../../initialState";

const addEmployment = (state=initialState, action) => {
  switch (action.type) {
    case types.ADD_EMPLOYMENT_START:
      return {
        ...state,
        isLoading: true
      };
    case types.ADD_EMPLOYMENT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        data: action.payload
      };
    case types.ADD_EMPLOYMENT_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    case types.ADD_EMPLOYMENT_CLEANUP:
      return {
        ...state,
        isLoading: false,
        isSuccessful: false,
        error: null
      };
    default:
      return state;
  }
}

export default addEmployment;
